module.exports = __webpack_public_path__ + "img/ZFBbarcode11.c6ce6dac.png";